import React from 'react';
import { renderProcessedText } from '../../utils/textRenderer';

interface OptionsSummaryCardProps {
  header?: string;
  title: string;
  description?: string;
  options: Array<{
    text: string;
    checked?: boolean;
  }>;
  isCarousel?: boolean;
}

const OptionsSummaryCard: React.FC<OptionsSummaryCardProps> = ({ header, title, description, options, isCarousel }) => {
  // Debug logging
  console.log('OptionsSummaryCard received props:', { header, title, description, options });
  console.log('Options type:', typeof options);
  console.log('Options length:', options?.length);
  
  // Handle cases where options might be undefined or not an array
  if (!options || !Array.isArray(options)) {
    return (
      <div className="options-summary-card">
        <div className="options-summary-card__container">
          {header && (
            <div className="options-summary-card__category">{header}</div>
          )}
          <h3 className="options-summary-card__title">{renderProcessedText(title || 'Options Summary')}</h3>
          <div className="options-summary-card__error">
            No options available
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="options-summary-card" style={{ height: isCarousel ? '100%' : 'auto' }}>
      <div className="options-summary-card__container">
        {header && (
          <div className="options-summary-card__category">{header}</div>
        )}
        <h3 className="options-summary-card__title">{renderProcessedText(title)}</h3>
        {description && (
          <p className="options-summary-card__description">{renderProcessedText(description)}</p>
        )}
        <div className="options-summary-card__options">
          {options.map((option, index) => (
            <div key={index} className="options-summary-card__option">
              <div className="options-summary-card__checkbox">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span className="options-summary-card__text">{renderProcessedText(option?.text || 'Option')}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OptionsSummaryCard;
